import { n as o, t } from "./l10n-ef44019c.mjs";
const n = {
  methods: {
    n: o,
    t
  }
};
export {
  n as l
};
